import { postWithRedirect } from 'utils/axios'

import { SIM } from 'redux/reducers/DataPlatform/SIM'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v3/standard-models`

export async function activateStandard() {
  return postWithRedirect<SIM>(URL, {})
}
